/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsPlatformAccount {
    getFixupPrototypeFunction() { return FilterOptionsPlatformAccount.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsPlatformAccount>): FilterOptionsPlatformAccount {
        let obj = Object.assign(new FilterOptionsPlatformAccount(), model);
        FilterOptionsPlatformAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsPlatformAccount>): FilterOptionsPlatformAccount {
        if (!model) return null;
        return FilterOptionsPlatformAccount.newInstance(<FilterOptionsPlatformAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsPlatformAccount) {
        if (!obj) return;

        models.FilterOptionsPlatformAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsPlatformAccount): boolean {
        Object.setPrototypeOf(obj, FilterOptionsPlatformAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates the status of the cloud account in corestack
     */
    status: models.ServiceAccountStatus;

    /**
     * ID of the platform account
     */
    platform_account_id: string;

    /**
     * Name of the platform account
     */
    platform_account_name: string;

    /**
     * Scope of the platform account
     */
    scope: models.ServiceAccountScope;

    /**
     * Currency for the platform account
     */
    currency: models.Currency;

}
